import { Tag, X } from "@phosphor-icons/react";
import { clsx } from "clsx";

export default function CouponPill({
  children,
  className,
  onRemove,
}: {
  children: string;
  className?: string;
  onRemove?: () => void;
}) {
  return (
    <div
      className={clsx(
        "pointer-events-none uppercase text-button-xs flex items-center hover:text-red-500 hover:bg-[linear-gradient(180deg,rgba(244,37,37,0.20)_0%,rgba(255,255,255,0.00)_50%)] hover:border-red-200 rounded-full text-yellow-500 px-1.25 py-0.75 border border-yellow-400 gap-x-1.5 shadow-sm bg-white bg-[linear-gradient(180deg,rgba(255,193,32,0.20)_0%,rgba(255,255,255,0.00)_50%)]",
        className,
      )}
    >
      <Tag size={16} weight="fill" />
      {children}
      {onRemove && (
        <button
          type="button"
          className="pointer-events-auto"
          onClick={onRemove}
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
}
